import React, { useState } from "react";
import { B2BLeadDashboard } from "./b2bleaddashboard";
import { B2CLeadDashboard } from "./b2cleadashboard";

const LeadDashboard = () => {
  const [activeAccount, setActiveAccount] = useState("B2B");

  return (
    <>
      {activeAccount === "B2B" ? (
        <B2BLeadDashboard
          onSwitchAccount={setActiveAccount}
        />
      ) : (
        <B2CLeadDashboard
          onSwitchAccount={setActiveAccount}
        />
      )}
    </>
  );
};

export default LeadDashboard;